module.exports = __webpack_public_path__ + "static/media/up-chevron-grey.a3052193.svg";